<template>
  <div>
    <div class="title"> 个人资料 </div>
    <div class="info-box">
      <div class="info-label">头像</div>
      <div class="info-content">
        <div class="avatar">
          <img v-if="userInfo.avatar" :src="userInfo.avatar" width="100%" height="100%" />
          <img
            v-else
            src="@/static/login/avatar.png"
            width="100%"
            height="100%"
            style="margin-left: -15px"
          />
        </div>
      </div>
    </div>
    <div class="info-box">
      <div class="info-label">用户名</div>
      <div class="info-content">{{ userInfo.username }}</div>
    </div>
    <div class="info-box">
      <div class="info-label">手机号码</div>
      <div class="info-content">{{ userInfo.phone }}</div>
    </div>
    <div class="info-box">
      <div class="info-label">所属角色</div>
      <div class="info-content" style="margin-bottom: -5px">
        <el-tag
          size="mini"
          v-for="item in roleList"
          :key="item.id"
          style="margin-right: 8px; margin-bottom: 5px"
          >{{ item.name }}</el-tag
        >
      </div>
    </div>
    <div class="info-box">
      <div class="info-label">创建日期</div>
      <div class="info-content">{{ userInfo.createTime }}</div>
    </div>
  </div>
</template>

<script >
import { computed } from '@vue/composition-api';
import store from '@/store';
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  const userInfo = computed(() => {
    return store.state.user.userInfo;
  });
  const roleList = computed(() => {
    const arr = userInfo.value && userInfo.value && userInfo.value.roleList || [];
    return arr;
  });
  return {
    userInfo,
    roleList
  };
};
export default __sfc_main;
</script>

<style lang="scss" scoped>
  .title {
    margin-bottom: 15px;
    font-size: 20px;
    font-weight: 700;
    color: #333333;
  }
  .info-box {
    margin-bottom: 30px;
    display: flex;
    align-items: center;
  }
  .info-label {
    width: 160px;
    font-size: 16px;
    font-weight: 400;
    color: #666666;
  }
  .info-content {
    width: 0;
    flex: 1;
    font-size: 14px;
    font-weight: 500;
    color: #333333;
  }
  .avatar {
    width: 98px;
    height: 98px;
    border-radius: 50%;
    overflow: hidden;
  }
</style>
